import { Box, Paper, Typography } from '@mui/material';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import LoginForm from '@organisms/Forms/Account/LoginForm';
import FormHeader from '@organisms/Forms/FormHeader';
import VersionDisplay from '@molecules/Display/VersionDisplay';
import LanguageSelector from '@molecules/LanguageSelector';
import { useGetEnvironnementQuery } from '@services/configApi';
import useT from '@hooks/useT';

function Login() {
  const { t } = useT();
  const { data: environnement } = useGetEnvironnementQuery();
  if (!environnement) return null;
  return (
    <GoogleReCaptchaProvider reCaptchaKey={environnement.recaptchaSiteKey}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          p: { xs: 2, sm: 4 },
          background: (theme) => 
            `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.secondary.main} 100%)`,
          minHeight: '100vh',
        }}>
        <Paper
          elevation={3}
          sx={{
            maxWidth: { xs: '100%', sm: 440 },
            width: '100%',
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: '0px 10px 25px rgba(0, 0, 0, 0.3)',
          }}>
          <Box 
            sx={{ 
              background: (theme) => 
                `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              py: 4,
              px: 3,
              textAlign: 'center',
            }}
          >
            <FormHeader>{t('app.title')}</FormHeader>
          </Box>
          <Box sx={{ p: { xs: 3, sm: 4 }, backgroundColor: 'background.paper' }}>
            <LoginForm />
            <Box sx={{ mt: 3, textAlign: 'center' }}>
              {!environnement.isProduction && (
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: 'warning.main',
                    fontSize: '0.8rem',
                    fontWeight: 600,
                    display: 'block',
                    textTransform: 'uppercase',
                  }}
                >
                  {environnement.environnementName}
                </Typography>
              )}
              <VersionDisplay />
            </Box>
          </Box>
        </Paper>
        <LanguageSelector variant="floating" />
      </Box>
    </GoogleReCaptchaProvider>
  );
}

export default Login;
